// @ts-nocheck
/* eslint-disable */
import { _ } from "~/i18n";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";

export function exportMultiroute(data) {

	if (!("id" in data) || !("title" in data)) { return; }

	var popup = new Mapy.DownloadPopup({
		data: data.id,
		type: Mapy.DownloadPopup.FOLDER,
		fileTypeFromHeader: true, //na základě známé Content-Type se nastaví koncovka souboru
		msg: _("mymap.places.exportMultiroute.popupText2"),
		onError: function () {
			Notifications.notify({
				content: _("mymap.activity.notify.downloadError"),
				type: NOTIFICATIONS_TYPE.ERROR
			});
		},
		onStartDownload: function() {
			popup.setWaitWindow(_("mymap.places.exportMultiroute.header"), _("mymap.places.exportMultiroute.message2"));
		},
		optionElements: {
			label: _("mymap.places.exportMultiroute.switch.label"),
			items: [
				{
					title: _("mymap.places.exportMultiroute.switch.shrink2"),
					type: "checkbox",
					name: "shrink",
					enabled: false
				},
				{
					title: _("mymap.places.exportMultiroute.switch.single2"),
					type: "checkbox",
					name: "single",
					enabled: true
				},
				{
					title: _("mymap.places.exportMultiroute.switch.tponly2"),
					type: "checkbox",
					name: "tponly",
					enabled: false,
					reverse: true
				}
			]
		}
	});
	popup.open();
}
